<template>
    <div class="page-container" :class="{ collapsed: !$store.getters.sidebarOpened }">
        <div class="area-container left-area">
            <el-scrollbar>
                <BuildTree ref="buildTree" :sourceData="treeData" @handleNodeClick="handleNodeClick" />
            </el-scrollbar>
        </div>
        <div class="data-container center-area">
            <div class="tool-box">
                <el-button type="primary" :icon="Refresh" @click="refreshTime">刷新</el-button>
                <el-button :icon="Upload" @click="exportData" v-permission="['thermostat:monitoring:batch-export']">
                    最新数据导出
                </el-button>
                <div class="total-box">
                    <span class="all">全部：{{ onlineNum + offlineNum }}</span>
                    <span class="online">在线：{{ onlineNum }}</span>
                    <span class="offline">离线：{{ offlineNum }}</span>
                    <span class="time">更新时间：</span>
                    <span class="time">{{ dateTime }}</span>
                </div>
            </div>
            <el-form class="search-form" :model="queryForms" label-position="top" inline>
                <el-form-item label="名称">
                    <el-input style="width: 165px" v-model="queryForms.name" clearable placeholder="请输入名称" />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="queryForms.online" placeholder="请选择状态" style="width: 165px" clearable>
                        <el-option
                            v-for="item in statusList"
                            :key="item.value"
                            :label="item.name"
                            :value="Number(item.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="IMEI">
                    <el-input style="width: 165px" placeholder="请输入IMEI" v-model="queryForms.IMEI" clearable />
                </el-form-item>
                <el-form-item label="ICCID">
                    <el-input style="width: 165px" placeholder="请输入ICCID" v-model="queryForms.ICCID" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :icon="Search" plain @click="handleSearch">搜索</el-button>
                    <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table
                class="data-table"
                :data="table_data"
                v-loading="tableLoading"
                @selection-change="handleSelectionChange"
                scrollbar-always-on
            >
                <el-table-column type="selection" width="30" align="center"></el-table-column>
                <el-table-column label="序号" type="index" fixed="left" width="60" align="center"></el-table-column>
                <el-table-column label="名称" fixed="left" prop="name" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column label="IMEI" width="150" prop="IMEI"></el-table-column>
                <el-table-column label="设备状态" width="100" prop="online" align="center">
                    <template #default="{ row }">
                        <el-tag v-if="row.online" type="success">在线</el-tag>
                        <el-tag v-else type="danger">离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="开关状态" width="100px" prop="real_time_status.switch">
                    <template #default="{ row }">
                        <el-tag v-if="row.real_time_status?.switch" type="success">开启</el-tag>
                        <el-tag v-else type="danger">关闭</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="运行模式" width="100px" prop="real_time_status.run_mode">
                    <template #default="{ row }">
                        {{ run_mode.find((item) => item.value === row.real_time_status?.run_mode)?.label || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="实时温度" width="100px" prop="temp"></el-table-column>
                <el-table-column label="设置温度" width="100px" prop="set_temp"></el-table-column>
                <el-table-column label="风速设状态" width="100px" prop="real_time_status.wind_speed">
                    <template #default="{ row }">
                        {{ speed.find((item) => item.value === row.real_time_status?.wind_speed)?.label || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="锁定状态" width="100px" prop="real_time_status.lock">
                    <template #default="{ row }">
                        {{ lockOptions.find((item) => item.value === row.real_time_status?.lock)?.label || '-' }}
                    </template>
                </el-table-column>
                <el-table-column label="实时湿度" width="100px" prop="humidity"></el-table-column>
                <el-table-column label="两管制冷热阀门状态" width="200" prop="real_time_status">
                    <template #default="{ row }">
                        <el-tag v-if="row.real_time_status?.valve === 1" type="success">开</el-tag>
                        <el-tag v-if="row.real_time_status?.valve === 0" type="danger">关</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="四管制热阀门状态" width="200" prop=""></el-table-column>
                <el-table-column label="安装位置" min-width="250px" prop="location" show-overflow-tooltip>
                    <template #default="{ row }">
                        <span v-show="row.room">{{ room_list[row.room] }}</span>
                        <span v-show="row.location">/{{ row.location }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="上传时间" width="150px" prop="last_collect_time"></el-table-column>
                <el-table-column label="操作" width="160px" fixed="right">
                    <template #default="{ row }">
                        <el-button type="primary" link @click="viewRecord(row)" v-permission="['thermostat:monitoring:record']">
                            历史数据
                        </el-button>
                        <el-button type="primary" link @click="viewChart(row.id)" v-permission="['thermostat:monitoring:chart']">
                            数据曲线
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <record-dialog v-model="show_record_dialog" :deviceId="device_id" :IMEI="device_IMEI" :deviceDetail="device_detail" />
            <chart-dialog v-model="show_chart_dialog" :deviceId="device_id" />
            <el-pagination
                class="pagination"
                v-if="table_data.length > 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryForms.page"
                :page-size="queryForms.page_size"
                :page-sizes="[10, 20, 50, 100]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
        </div>
        <!-- <div class="alarm-container right-area">
            <alarm-list more-page-path="/valve/valve-history-event" :type="3"></alarm-list>
        </div> -->
    </div>
</template>

<script setup>
import { nextTick, onMounted, ref, reactive } from 'vue'
import BuildTree from '@/components/BuildTree/index'
import { Refresh, Search, Upload } from '@element-plus/icons'
import AlarmList from '@/components/Equipment/List/index'
import { getDeviceList, HVACReportDataTimeExport } from '@/api/thermostat/devicePoint.js'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import RecordDialog from './components/RecordDialog.vue'
import ChartDialog from './components/ChartDialog.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'
import { lockOptions, speed, run_mode } from '@/constant/index.js'
// 切换楼层数据
const current_node = ref({})
const handleNodeClick = (row) => {
    current_node.value = row.node
    getTableData()
}

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children &&
                device_type?.children &&
                device_type.children?.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    const room_locations = {}
    function getRoom(list, location) {
        list.forEach((item) => {
            if (item.children) {
                getRoom(item.children, location + '/' + item.name)
            } else {
                room_locations[item.id] = location.slice(1) + '/' + item.name
            }
        })
    }
    await getOptionTree().then((data) => {
        getRoom(data[0]?.children ?? [], '')
        room_list.value = room_locations
    })
}

// 状态列表
const statusList = [
    { name: '在线', value: 1 },
    { name: '离线', value: 0 }
]

// 数据源
const queryForms = ref({
    name: '',
    online: '',
    building: '',
    model: '',
    page: 1,
    page_size: 20
})
const total = ref(0)
// 在线离线数量
const onlineNum = ref(0)
const offlineNum = ref(0)
// 重置
const resetQueryForm = () => {
    queryForms.value = {
        name: '',
        online: '',
        building: '',
        page: 1,
        page_size: 20
    }
    total.value = 0
    getTableData()
}
// 搜索回到第一页
const handleSearch = () => {
    queryForms.value.page = 1
    getTableData()
}
// 格式化对象
const getNowDate = () => {
    const date = new Date()
    const sign2 = ':'
    const year = date.getFullYear() // 年
    let month = date.getMonth() + 1 // 月
    let day = date.getDate() // 日
    let hour = date.getHours() // 时
    let minutes = date.getMinutes() // 分
    let seconds = date.getSeconds() // 秒
    if (month >= 1 && month <= 9) {
        month = '0' + month
    }
    if (day >= 0 && day <= 9) {
        day = '0' + day
    }
    if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds
    }
    return year + '-' + month + '-' + day + ' ' + hour + sign2 + minutes + sign2 + seconds
}

// 获取左侧树状结构
const treeData = ref([])
const treeLoading = ref(false)
async function getTreeData() {
    treeLoading.value = true
    await getOptionTree().then((data) => {
        const roomAddLevel = (list, level = 1) => {
            list.forEach((item) => {
                item.is_leaf = false
                item.level = level
                if (item.children) {
                    roomAddLevel(item.children, item.level + 1)
                }
            })
        }
        roomAddLevel(data, 1)
        treeData.value = data
        nextTick(() => {
            current_node.value = treeData.value[0]
        })
    })
    treeLoading.value = false
}

// 刷新时间
const dateTime = ref('')
dateTime.value = getNowDate()
const refreshTime = async () => {
    dateTime.value = getNowDate()
    resetQueryForm()
}

// 表格数据
const table_data = ref([])
const tableLoading = ref(false)
const getTableData = async () => {
    tableLoading.value = true
    const params = { ...queryForms.value }
    if (params.online === '') delete params.online
    if (current_node.value?.level < 6) {
        params.building = current_node.value.id
    } else if (current_node.value?.level === 6) {
        params.room = current_node.value.id
    }
    getDeviceList(params).then((data) => {
        onlineNum.value = data.online_count || 0
        offlineNum.value = data.offline_count || 0
        table_data.value = data.lists.map((item) => {
            const device_info = { ...item }
            device_info.in_temp = Number(item.in_temp)
            device_info.out_temp = Number(item.out_temp)
            return device_info
        })
        total.value = data.total
        tableLoading.value = false
    })
}

// 分页
const handleSizeChange = (currentSize) => {
    queryForms.value.page_size = currentSize
    queryForms.value.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    queryForms.value.page = currentPage
    getTableData()
}

// 表格多选
const selected_list = ref([])
function handleSelectionChange(list) {
    selected_list.value = list.map((item) => {
        return item.id
    })
}

// 最新数据导出
function exportData() {
    if (selected_list.value.length == 0) {
        return ElMessage.error('请选择需要导出的设备')
    }
    let loading = null
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
    })
        .then(async () => {
            loading = ElLoading.service({
                lock: true,
                text: '正在导出...',
                spinner: 'Loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            let list = await HVACReportDataTimeExport({
                id_list: selected_list.value
            })
            console.log('🚀 ~ exportData ~ list:', list)
            if (list.length <= 0) {
                loading.close()
                return ElMessage.error('没有数据可导出')
            }
            // 创建excel并写入数据
            const workbook = new Exceljs.Workbook()
            workbook.created = new Date()
            workbook.modified = new Date()
            const worksheet = workbook.addWorksheet('设备配置数据', {
                properties: { defaultRowHeight: 22 },
                pageSetup: { horizontalCentered: true }
            })

            // 严格匹配表格列顺序和表头，无多余字段
            worksheet.columns = [
                { header: '序号', key: 'index', width: 10 },
                { header: '名称', key: 'name', width: 20 },
                { header: 'IMEI', key: 'IMEI', width: 18 },
                { header: 'ICCID', key: 'ICCID', width: 23 },
                { header: '设备状态', key: 'online', width: 10 },
                { header: '开关状态', key: 'set_switch', width: 12 },
                { header: '运行模式', key: 'set_run_mode', width: 12 },
                { header: '实时温度', key: 'temp', width: 12 },
                { header: '设置温度', key: 'set_temp', width: 12 },
                { header: '风速设状态', key: 'set_wind_speed', width: 12 },
                { header: '锁定状态', key: 'set_lock', width: 12 },
                { header: '实时湿度', key: 'humidity', width: 12 },
                { header: '两管制冷热阀门状态', key: 'valve', width: 20 },
                { header: '四管制热阀门状态', key: '', width: 20 },
                { header: '安装位置', key: 'location', width: 80 },
                { header: '上传时间', key: 'update_time', width: 25 }
            ]

            // 数据映射完全同步表格显示逻辑
            worksheet.addRows(
                list.map((row, index) => {
                    // 安装位置拼接（与表格一致：room名称 + 详细location）
                    const installLocation = row.room_show
                    // 运行模式标签映射
                    const runModeLabel = run_mode.find((item) => item.value === row.run_mode)?.label || '-'
                    // 风速标签映射
                    const windSpeedLabel = speed.find((item) => item.value === row.wind_speed)?.label || '-'
                    // 锁定状态标签映射
                    const lockLabel = lockOptions.find((item) => item.value === row.lock)?.label || '-'
                    const valvelabel = row?.valve === 1 ? '开' : row?.valve === 0 ? '关' : '-'
                    return {
                        index: index + 1, // 序号自增（与表格一致）
                        name: row.name,
                        IMEI: row.IMEI,
                        ICCID: row.ICCID,
                        online: row.online ? '在线' : '离线', // 状态标签（与表格一致）
                        set_switch: row.switch ? '开启' : '关闭', // 开关状态文字
                        set_run_mode: runModeLabel,
                        temp: row.temp,
                        set_temp: row.set_temp,
                        set_wind_speed: windSpeedLabel,
                        set_lock: lockLabel,
                        humidity: row.humidity,
                        location: installLocation,
                        update_time: row.update_time,
                        valve: valvelabel
                    }
                })
            )

            // 表头样式优化（居中+加粗）
            const headerRow = worksheet.getRow(1)
            headerRow.alignment = { horizontal: 'center', vertical: 'middle' }
            headerRow.font = { bold: true }

            // 导出excel文件
            await workbook.xlsx.writeBuffer().then((buffer) => {
                const date = new Date()
                const [year, month, day, hour, minutes, seconds] = [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0'),
                    String(date.getHours()).padStart(2, '0'),
                    String(date.getMinutes()).padStart(2, '0'),
                    String(date.getSeconds()).padStart(2, '0')
                ]
                const fileName = `温控器设备配置数据_${year}${month}${day}_${hour}${minutes}${seconds}.xlsx`
                FileSaver.saveAs(new Blob([buffer]), fileName)
            })

            loading.close()
            ElMessage.success('导出成功！')
        })
        .catch((res) => {
            console.error(res)
            loading.close()
            ElMessage.error(res.message || '导出失败！')
        })
}

// 选中的设备id
const device_id = ref('') // 点中的模块id

const device_IMEI = ref('')
const device_detail = ref({})

// 查看历史采集数据
const show_record_dialog = ref(false)
function viewRecord(row) {
    device_id.value = row.id
    device_IMEI.value = row.IMEI
    device_detail.value = row
    show_record_dialog.value = true
}

// 数据曲线
const show_chart_dialog = ref(false)
function viewChart(id) {
    device_id.value = id
    show_chart_dialog.value = true
}

onMounted(async () => {
    tableLoading.value = true
    await getTreeData()
    await getModelList()
    await getRoomTree()
    await getTableData()
})
</script>

<style lang="scss" scoped></style>
